import React, {Component} from 'react';
import HeadlessLayout from './headless';
import BaseLayout from './base';
import {withRouter} from 'react-router-dom';
import './index.scss';

class Layout extends Component {
  render() {
    const ChildComponent = this.props.component;
    let props = this.props;
    delete props.children;

    if (props.layout === 'headless') {
      return (
        <HeadlessLayout>
          <ChildComponent {...props} />
        </HeadlessLayout>
      )
    }

    return <BaseLayout><ChildComponent {...props} /></BaseLayout>
  }
}

export default withRouter(Layout);